import React from 'react';
import cn from 'classnames';

import { Done } from '@/icons';

import styles from './done-card.module.scss';

interface IProps {
  className: string;
  text: string;
}

const DoneCard: React.FC<IProps> = (props) => {
  const { className, text } = props;

  return (
    <div className={cn(styles.card, className)}>
      <Done className={styles.card__icon} />
      <p className={styles.card__text}>{text}</p>
    </div>
  );
};

export default DoneCard;
